var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLounge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF754C",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2892_6147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 23.957V26.695H11.1719V23.957H10V26.9311C10 27.8132 10.5811 28.5621 11.3806 28.8153V29.9999H12.5525V28.9071H27.4475V29.9999H28.6194V28.8153C29.4189 28.5621 30 27.8132 30 26.9311V23.957H28.8281Z",
    fill: "#FF754C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6563 25.5402V25.524V21.1158C16.6563 20.437 16.106 19.8867 15.4272 19.8867H13.5807C12.9018 19.8867 12.3516 20.437 12.3516 21.1158V25.524V25.5402H16.6563Z",
    fill: "#FF754C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.172 25.5402V25.524V21.1158C22.172 20.437 21.6216 19.8867 20.9429 19.8867H19.0572C18.3784 19.8867 17.8281 20.437 17.8281 21.1158V25.524V25.5402H22.172Z",
    fill: "#FF754C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6485 25.5402V25.524V21.1158C27.6485 20.437 27.0982 19.8867 26.4194 19.8867H24.5729C23.894 19.8867 23.3438 20.437 23.3438 21.1158V25.524V25.5402H27.6485Z",
    fill: "#FF754C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001 16.9238C21.9099 16.9238 23.4629 15.3708 23.4629 13.4619C23.4629 11.553 21.9099 10 20.001 10C18.0921 10 16.5391 11.553 16.5391 13.4619C16.5391 15.3708 18.0921 16.9238 20.001 16.9238ZM19.415 13.4834V11.6416H20.5869V14.0349L19.1782 15.2505L18.4313 14.3475L19.415 13.4834Z",
    fill: "#FF754C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2892_6147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLounge);
export default __webpack_public_path__ + "static/media/lounge.93ee673d2aab83e917c53284e2cc5c2e.svg";
export { ForwardRef as ReactComponent };